import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    // 페이지 전환 직후엔 DOM이 아직 마운트 안 됐을 수 있음
    const id = hash.slice(1);
    const scroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    // 한 프레임 양보 — 라우트 전환 시 타겟 섹션이 mount될 시간 확보
    requestAnimationFrame(scroll);
  }, [pathname, hash]);

  return null;
}